// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"41b5fcb9e13d8f6f00bf","682":"29118ab3ad436ae09083","883":"8b1de5f2bdaa6f84b8e7"}[chunkId] + ".js";
};